import { render, staticRenderFns } from "./invoiceInformation.vue?vue&type=template&id=20b3de80&scoped=true&"
import script from "./invoiceInformation.vue?vue&type=script&lang=js&"
export * from "./invoiceInformation.vue?vue&type=script&lang=js&"
import style0 from "./invoiceInformation.vue?vue&type=style&index=0&id=20b3de80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b3de80",
  null
  
)

export default component.exports